
import _ from 'underscore'
import Backbone from 'backbone'
import HitAreaSelection from './HitAreaSelection'
import LevelCollection from '../collections/LevelCollection'
import UnitSelection from './UnitSelection'

function tag(key) {
  return 'tag' + key
}

function tags(obj) {
  let tags = {}
  _.each(obj, (value, key) => tags['tag' + key] = value.toString())
  return tags
}

class LevelSelection {

  constructor(collection, mapModel) {
    if (_.isArray(collection)) {
      collection = new LevelCollection(collection)
    }

    function subselect(models) {
      return new LevelSelection(models, mapModel)
    }

    this.length = collection.length
    
    this.where = function (match = {}) {
      return subselect(collection.where(tags(match)))
    }

    this.has = function (query = {}) {
      let keys = {include: [], exclude: []}
      _.each(query, (value, key) => {
        keys[value === true ? 'include' : 'exclude'].push(tag(key))
      })

      return new subselect(collection.filter(model => {
        return _.every(keys.include, key => model.has(key))
          && _.every(keys.exclude, key => !model.has(key))
      }))
    }

    this.except = function (match = {}) {
      return new subselect(collection.reject(tags(match)))
    }

    this.find = function (id) {
      let model = collection.get(id)

      if (!model) {
        model = collection.findWhere({uid: id})
      }

      return model
        ? subselect([model])
        : subselect([])
    }

    this.select = function (selector) {
      let models = []
      
      switch(selector) {
        case 'hitareas': 
          collection.each(model => models = models.concat(model.get('hitareas').models))
          return new HitAreaSelection(models)
        case 'units':
          collection.each(model => models = models.concat(model.get('units').models))
          return new UnitSelection(models)
        default:
          throw new Error(`"${selector}" is not a valid selector on a LevelSection instance.`)
      }
    }

    this.first = function () {
      return this.at(0)
    }

    this.at = function (index) {
      return index >= 0 && index < collection.length
        ? subselect([collection.at(index)])
        : subselect([])
    }

    this.transition = function (properties, duration = 350, ease = 'cubic-in-out') {
      collection.transition(properties, duration, ease)
      return this
    }

    this.translate = function (x, y) {
      collection.translate(x, y)
      return this
    }

    this.scale = function (scale) {
      collection.scale(scale)
      return this
    }

    this.each = function (iterator) {
      collection.facades().forEach(iterator)
      return this
    }

    this.clone = function (id, tags) {
      let clone = null
      if (collection.length > 0) {
        clone = collection.first().clone(id, tags)
      }

      return clone
        ? subselect([clone])
        : subselect([])
    }

    this.remove = function () {
      mapModel.get('levels').remove(collection.models)
      return this
    }

    this.hide = function () {
      collection.hide()
      return this
    }

    this.show = function () {
      collection.show()
      return this
    }

    this.opacity = function (opacity) {
      collection.opacity(opacity)
      return this
    }

    this.data = function () {
      return collection.data()
    }
  }
}

export default LevelSelection
